<ng-template let-t transloco>
    <div class="filter-container flex-auto sm:flex-none flex flex-wrap flex-col sm:flex-row">
        <button
            [matMenuTriggerFor]="firstLevel"
            class="mt-2 sm:mt-4 flex-auto sm:flex-none"
            color="primary"
            mat-flat-button
            tabindex="1">
            <div class="inline-flex items-center">
                <span class="border-r border-gray-300 pr-3 mr-3">{{t('filter')}}</span>
                <mat-icon [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
            </div>

        </button>

        <ng-container *ngFor="let user of currentFilter.users; trackBy: trackByFn">
            <div
                class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-unthemed mat-mdc-button-base sm:ml-4 mt-2 sm:mt-4 flex-auto sm:flex-none cursor-auto flex items-center"
                tabindex="1">
                <mat-icon *ngIf="!user.logo?.fileName" [svgIcon]="'heroicons_outline:users'" ></mat-icon>
                <img *ngIf="user.logo?.fileName"
                        [src]="platformService.getFileSrc(user.logo, 'avatar')"
                        class="w-6 h-6 rounded-md object-contain">
                <span class="border-r border-gray-300 pr-3 ml-2 mr-2">{{user.title}}</span>
                <mat-icon (click)="removeFilter('users', user)" [svgIcon]="'heroicons_outline:x-mark'" class="cursor-pointer"></mat-icon>
            </div>
        </ng-container>

        <ng-container *ngFor="let artist of currentFilter.artists; trackBy: trackByFn">
            <div
                class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-unthemed mat-mdc-button-base sm:ml-4 mt-2 sm:mt-4 flex-auto sm:flex-none cursor-auto flex items-center"
                tabindex="1">
                <mat-icon [svgIcon]="'heroicons_outline:user'" ></mat-icon>
                <span class="border-r border-gray-300 pr-3 ml-2 mr-2">{{artist.title}}</span>
                <mat-icon (click)="removeFilter('artists', artist)" [svgIcon]="'heroicons_outline:x-mark'" class="cursor-pointer"></mat-icon>
            </div>
        </ng-container>

        <ng-container *ngFor="let release of currentFilter.releases; trackBy: trackByFn">
            <div
                class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-unthemed mat-mdc-button-base sm:ml-4 mt-2 sm:mt-4 flex-auto sm:flex-none cursor-auto flex items-center"
                [ngClass]="{'cursor-not-allowed': preSelectedRelease?.uuid === release.uuid}"
                tabindex="1">
                <mat-icon [svgIcon]="'heroicons_outline:folder'" ></mat-icon>
                <span [ngClass]="{'border-r border-gray-300 pr-3 ml-2 mr-2': preSelectedRelease?.uuid !== release.uuid}">{{release.title}}</span>
                <mat-icon (click)="removeFilter('releases', release)" *ngIf="preSelectedRelease?.uuid !== release.uuid" [svgIcon]="'heroicons_outline:x-mark'" class="cursor-pointer"></mat-icon>
            </div>
        </ng-container>

        <ng-container *ngFor="let track of currentFilter.tracks; trackBy: trackByFn">
            <div
                class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-unthemed mat-mdc-button-base sm:ml-4 mt-2 sm:mt-4 flex-auto sm:flex-none cursor-auto flex items-center"
                tabindex="1">
                <mat-icon [svgIcon]="'heroicons_outline:musical-note'" ></mat-icon>
                <span class="border-r border-gray-300 pr-3 ml-2 mr-2">{{track.title}}</span>
                <mat-icon (click)="removeFilter('tracks', track)" [svgIcon]="'heroicons_outline:x-mark'" class="cursor-pointer"></mat-icon>
            </div>
        </ng-container>

        <ng-container *ngFor="let label of currentFilter.labels; trackBy: trackByFn">
            <div
                class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-unthemed mat-mdc-button-base sm:ml-4 mt-2 sm:mt-4 flex-auto sm:flex-none cursor-auto flex items-center"
                tabindex="1">
                <mat-icon [svgIcon]="'heroicons_outline:building-office'"></mat-icon>
                <span class="border-r border-gray-300 pr-3 ml-2 mr-2">{{label.title}}</span>
                <mat-icon (click)="removeFilter('labels', label)" [svgIcon]="'heroicons_outline:x-mark'" class="cursor-pointer"></mat-icon>
            </div>
        </ng-container>

        <ng-container *ngFor="let store of currentFilter.stores; trackBy: trackByFn">
            <div
                class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-unthemed mat-mdc-button-base sm:ml-4 mt-2 sm:mt-4 flex-auto sm:flex-none cursor-auto flex items-center"
                tabindex="1">
                <img *ngIf="store.logo" [alt]="'Logo'"
                        [src]="platformService.getFileSrc(store.logo, 'logo')"
                        class="w-6 h-6 rounded-md object-contain">
                <mat-icon *ngIf="!store.logo" [svgIcon]="'heroicons_outline:shopping-cart'" ></mat-icon>
                <span class="border-r border-gray-300 pr-3 ml-2 mr-2">{{store.title}}</span>
                <mat-icon (click)="removeFilter('stores', store)" [svgIcon]="'heroicons_outline:x-mark'" class="cursor-pointer"></mat-icon>
            </div>
        </ng-container>

        <ng-container *ngFor="let type of currentFilter.types; trackBy: trackByFn">
            <div
                class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-unthemed mat-mdc-button-base sm:ml-4 mt-2 sm:mt-4 flex-auto sm:flex-none cursor-auto flex items-center"
                tabindex="1">
                <mat-icon [svgIcon]="'heroicons_outline:signal'" ></mat-icon>
                <span class="border-r border-gray-300 pr-3 ml-2 mr-2">{{getTypeName(type.uuid)}}</span>
                <mat-icon (click)="removeFilter('types', type)" [svgIcon]="'heroicons_outline:x-mark'" class="cursor-pointer"></mat-icon>
            </div>
        </ng-container>

        <ng-container *ngFor="let country of currentFilter.countries; trackBy: trackByFn">
            <div
                class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-unthemed mat-mdc-button-base sm:ml-4 mt-2 sm:mt-4 flex-auto sm:flex-none cursor-auto flex items-center"
                tabindex="1">
                <mat-icon [svgIcon]="'heroicons_outline:globe-alt'" ></mat-icon>
                <span class="border-r border-gray-300 pr-3 ml-2 mr-2">{{getCountryName(country.uuid)}}</span>
                <mat-icon (click)="removeFilter('countries', country)" [svgIcon]="'heroicons_outline:x-mark'" class="cursor-pointer"></mat-icon>
            </div>
        </ng-container>

        <mat-menu #firstLevel="matMenu">
            <button (menuOpened)="loadFilterData('users')" *ngIf="!preSelectedRelease && showFilter('users') && (user.role === 'partner' || user.role === 'admin' || (user.role === 'marketing' && user.permissions.topUsersAccess))" [matMenuTriggerFor]="usersMenu" mat-menu-item>
                <mat-icon [svgIcon]="'heroicons_outline:users'" class="mr-2"></mat-icon>
                {{t('users')}}</button>
            <button (menuOpened)="loadFilterData('artists')" *ngIf="!preSelectedRelease && showFilter('artists')" [matMenuTriggerFor]="artistsMenu" mat-menu-item>
                <mat-icon [svgIcon]="'heroicons_outline:user'" class="mr-2"></mat-icon>
                {{t('artists')}}</button>
            <button (menuOpened)="loadFilterData('releases')" *ngIf="!preSelectedRelease && showFilter('releases')" [matMenuTriggerFor]="releasesMenu" mat-menu-item>
                <mat-icon [svgIcon]="'heroicons_outline:folder'" class="mr-2"></mat-icon>
                {{t('releases')}}
            </button>
            <button *ngIf="currentFilter?.releases?.length || preSelectedRelease && showFilter('tracks')" (menuOpened)="loadFilterData('tracks')" [matMenuTriggerFor]="tracksMenu" mat-menu-item>
                <mat-icon [svgIcon]="'heroicons_outline:musical-note'" class="mr-2"></mat-icon>
                {{t('songs')}}
            </button>
            <button (menuOpened)="loadFilterData('labels')" *ngIf="!preSelectedRelease && showFilter('labels') && (user.role === 'partner' || user.role === 'admin' || user.role === 'marketing' || user.role === 'label')" [matMenuTriggerFor]="labelsMenu" mat-menu-item>
                <mat-icon [svgIcon]="'heroicons_outline:building-office'" class="mr-2"></mat-icon>
                {{t('labels')}}
            </button>
            <button (menuOpened)="loadFilterData('stores')" *ngIf="showFilter('stores')" [matMenuTriggerFor]="storesMenu" mat-menu-item>
                <mat-icon [svgIcon]="'heroicons_outline:shopping-cart'" class="mr-2"></mat-icon>
                {{t('stores')}}
            </button>
            <button [matMenuTriggerFor]="distributionTypesMenu" *ngIf="showFilter('types')" mat-menu-item>
                <mat-icon [svgIcon]="'heroicons_outline:signal'" class="mr-2"></mat-icon>
                {{t('type')}}
            </button>
            <button [matMenuTriggerFor]="countriesMenu" *ngIf="showFilter('countries')" mat-menu-item>
                <mat-icon [svgIcon]="'heroicons_outline:globe-alt'" class="mr-2"></mat-icon>
                {{t('countries')}}
            </button>
        </mat-menu>

        <form [formGroup]="searchForm">
            <mat-menu #usersMenu="matMenu">
                <ng-template matMenuContent>
                    <mat-form-field (click)="stopPropagation($event)" class="w-full px-4 fuse-mat-no-subscript">
                        <input autocomplete="off" formControlName="users" matInput maxlength="256" [placeholder]="'search-placeholder' | transloco">
                        <button (click)="stopPropagation($event); searchForm.get('users').setValue('');" [ngClass]="{'opacity-0': !searchForm.get('users').value}"
                                aria-label="Clear" class="opacity-1 transition-opacity duration-150" mat-icon-button matSuffix>
                            <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                        </button>
                    </mat-form-field>
                    <ng-container *ngFor="let user of analyticsService.userFilters$ | async; trackBy: trackByFn">
                        <button (click)="addFilter('users', {uuid: user.uuid, title: getFullUserName(user)})"
                                class="mat-mdc-menu-item">{{getFullUserName(user)}}</button>
                    </ng-container>
                </ng-template>
            </mat-menu>

            <mat-menu #artistsMenu="matMenu">
                <ng-template matMenuContent>
                    <mat-form-field (click)="stopPropagation($event)" class="w-full px-4 fuse-mat-no-subscript">
                        <input autocomplete="off" formControlName="artists" matInput maxlength="256" [placeholder]="'search-placeholder' | transloco">
                        <button (click)="stopPropagation($event); searchForm.get('artists').setValue('');" [ngClass]="{'opacity-0': !searchForm.get('artists').value}"
                                aria-label="Clear" class="opacity-1 transition-opacity duration-150" mat-icon-button matSuffix>
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <ng-container *ngFor="let artist of analyticsService.artistFilters$ | async; trackBy: trackByFn">
                        <button (click)="addFilter('artists', {uuid: artist.uuid, title: artist.title})" class="mat-mdc-menu-item">{{artist.title}}</button>
                    </ng-container>
                </ng-template>
            </mat-menu>

            <mat-menu #releasesMenu="matMenu">
                <ng-template matMenuContent>
                    <mat-form-field (click)="stopPropagation($event)" class="w-full px-4 fuse-mat-no-subscript">
                        <input autocomplete="off" formControlName="releases" matInput maxlength="256" [placeholder]="'search-placeholder' | transloco">
                        <button (click)="stopPropagation($event); searchForm.get('releases').setValue('');" [ngClass]="{'opacity-0': !searchForm.get('releases').value}"
                                aria-label="Clear" class="opacity-1 transition-opacity duration-150" mat-icon-button matSuffix>
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <ng-container *ngFor="let release of analyticsService.releaseFilters$ | async; trackBy: trackByFn">
                        <button (click)="addFilter('releases', {uuid: release.uuid, title: release.title})" class="mat-mdc-menu-item">{{release.title}}</button>
                    </ng-container>
                </ng-template>
            </mat-menu>

            <mat-menu #tracksMenu="matMenu">
                <ng-template matMenuContent>
                    <!--<mat-form-field (click)="stopPropagation($event)" class="w-full px-4 fuse-mat-no-subscript" appearance="standard">
                        <input matInput formControlName="tracks" maxlength="256" placeholder="Search..." autocomplete="off">
                        <button class="opacity-1 transition-opacity duration-150" [ngClass]="{'opacity-0': !searchForm.get('tracks').value}" matSuffix mat-icon-button aria-label="Clear" (click)="stopPropagation($event); searchForm.get('tracks').setValue('');">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>-->
                    <ng-container *ngFor="let track of analyticsService.trackFilters$ | async; trackBy: trackByFn">
                        <button (click)="addFilter('tracks', {uuid: track.uuid, title: track.title})" class="mat-mdc-menu-item">{{track.title + (track.version ? " ("+track.version+")" : "")}}</button>
                    </ng-container>
                </ng-template>
            </mat-menu>

            <mat-menu #labelsMenu="matMenu">
                <ng-template matMenuContent>
                    <mat-form-field (click)="stopPropagation($event)" class="w-full px-4 fuse-mat-no-subscript">
                        <input autocomplete="off" formControlName="labels" matInput maxlength="256" [placeholder]="'search-placeholder' | transloco">
                        <button (click)="stopPropagation($event); searchForm.get('labels').setValue('');" [ngClass]="{'opacity-0': !searchForm.get('labels').value}"
                                aria-label="Clear" class="opacity-1 transition-opacity duration-150" mat-icon-button matSuffix>
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <ng-container *ngFor="let label of analyticsService.labelFilters$ | async; trackBy: trackByFn">
                        <button (click)="addFilter('labels', {uuid: label.uuid, title: label.title})" class="mat-mdc-menu-item">{{label.title}}</button>
                    </ng-container>
                </ng-template>
            </mat-menu>

            <mat-menu #storesMenu="matMenu">
                <ng-template matMenuContent>
                    <ng-container *ngFor="let store of analyticsService.stores$ | async; trackBy: trackByFn">
                        <button (click)="addFilter('stores', store)" class="mat-mdc-menu-item">
                            <img *ngIf="store.logo" [alt]="'Logo'"
                                    [src]="platformService.getFileSrc(store.logo, 'logo')"
                                    class="w-6 h-6 mr-2 rounded-md object-contain">
                            {{store.title}}
                        </button>
                    </ng-container>
                </ng-template>
            </mat-menu>

            <mat-menu #distributionTypesMenu="matMenu">
                <ng-template matMenuContent>
                    <button (click)="addFilter('types', {uuid: 'stream'})" *ngIf="!currentFilter.types?.length || currentFilter.types[0].uuid === 'stream'" class="mat-mdc-menu-item">
                        Stream
                    </button>
                    <button (click)="addFilter('types', {uuid: 'download'})" *ngIf="!currentFilter.types?.length || currentFilter.types[0].uuid === 'download'" class="mat-mdc-menu-item">
                        Download
                    </button>
                    <button (click)="addFilter('types', {uuid: 'creation'})" *ngIf="!currentFilter.types?.length || currentFilter.types[0].uuid === 'creation'" class="mat-mdc-menu-item">
                        Creation
                    </button>
                </ng-template>
            </mat-menu>

            <mat-menu #countriesMenu="matMenu">
                <ng-template matMenuContent>
                    <mat-form-field (click)="stopPropagation($event)" appearance="outline" class="w-full px-4 fuse-mat-no-subscript">
                        <input autocomplete="off" formControlName="countries" matInput maxlength="256" [placeholder]="'search-placeholder' | transloco">
                        <button (click)="stopPropagation($event); searchForm.get('countries').setValue('');" [ngClass]="{'opacity-0': !searchForm.get('countries').value}"
                                aria-label="Clear" class="opacity-1 transition-opacity duration-150" mat-icon-button matSuffix>
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                    <ng-container *ngFor="let country of filteredCountries; trackBy: trackByFn">
                        <button (click)="addFilter('countries', {uuid: country.uuid, title: country.name})" class="mat-mdc-menu-item">
                            <img *ngIf="country.flagImage" [alt]="'Flag'"
                                    [src]="country.flagImage"
                                    class="w-6 h-6 mr-2 object-contain">
                            <!-- <div
                                [style.background]="'url(\'/assets/images/flags/flags.png\') ' +utilService.getFlagPositionForCountry(country) + ' / 24px 3876px no-repeat'"
                                class="min-w-6 w-6 h-4 overflow-hidden mr-2"></div> -->
                            {{country.name}}
                        </button>
                    </ng-container>
                </ng-template>
            </mat-menu>

        </form>

    </div>
</ng-template>
